import React, { useState, useEffect } from 'react';
import VideoLoader from './VideoLoader';

function Video() {
    // Session me pehli baar hi splash dikhao, baad me kabhi nahi
    const [loading, setLoading] = useState(
        () => !sessionStorage.getItem("splashShown")
    );

    useEffect(() => {
        if (!loading) return;

        // Fallback: 3 second me pakka band — chahe kuch bhi ho
        const timer = setTimeout(() => {
            sessionStorage.setItem("splashShown", "1");
            setLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, [loading]);

    return (
        <div className='video-content'>
            {loading && <VideoLoader />}
        </div>
    );
}

export default Video;